// extracted by mini-css-extract-plugin
module.exports = {"widgetsSection":"WidgetsSection_widgetsSection__2gZGs"};